import React, { useEffect } from 'react';
import {
	CmdbUpsellPageContainer,
	useUserHasDismissed,
} from '@atlassian/jira-cmdb-upsell-page/src/controllers/index.tsx';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { fireTrackAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { isCMDBEnabledInEnvironment } from '@atlassian/jira-servicedesk-cmdb-fedramp/src/index.tsx';
import { isLicensedPremiumUser } from '@atlassian/jira-servicedesk-insight-common-workspace-context/src/services/resources/get-data/index.tsx';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { TopLevelErrorBoundary } from '../../common/ui/error-boundary/index.tsx';
import PopupBoxWrapper from '../../common/ui/popup-box-wrapper/index.tsx';
import { InsightMenuItem } from './main.tsx';

export const useShowAssets = () => {
	const tenantContext = useTenantContext();
	const { appPermissions } = tenantContext;

	const isJSMUser = appPermissions.hasServiceDeskAccess;

	if (isCMDBEnabledInEnvironment(tenantContext.cmdbDisabledInFedRAMP)) {
		if (isJSMUser) {
			return true;
		}
	}
	return false;
};

const Insight = () => {
	const tenantContext = useTenantContext();
	const { appPermissions } = tenantContext;
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const isPremiumUser = isLicensedPremiumUser(tenantContext);
	const isJSMUser = appPermissions.hasServiceDeskAccess;
	const [hasDismissed] = useUserHasDismissed();

	const showUpsell = hasDismissed === false && isJSMUser;

	useEffect(() => {
		if (!isPremiumUser && showUpsell) {
			// fire analytics event only for non-premium users that haven't dimissed the Assets upsell page button.
			fireTrackAnalytics(createAnalyticsEvent({}), 'cmdbUpsellPageButton viewed', {
				serviceDeskEdition: tenantContext.appEditions?.serviceDesk,
				isSiteAdmin: tenantContext.isSiteAdmin,
			});
		}
	}, [
		createAnalyticsEvent,
		isPremiumUser,
		showUpsell,
		tenantContext.appEditions?.serviceDesk,
		tenantContext.isSiteAdmin,
	]);

	return (
		<JSErrorBoundary id="InsightNavMenu" packageName="jiraAtlassianNavigation" fallback="unmount">
			{(!isPremiumUser && showUpsell) || isPremiumUser ? <InsightMenuItem /> : null}
		</JSErrorBoundary>
	);
};

const InsightWihErrorBoundary = () => {
	const atlassianAccountId = useAccountId();
	return (
		<TopLevelErrorBoundary id={MENU_ID.INSIGHT}>
			<CmdbUpsellPageContainer isGlobal atlassianAccountId={atlassianAccountId}>
				<PopupBoxWrapper>
					<Insight />
				</PopupBoxWrapper>
			</CmdbUpsellPageContainer>
		</TopLevelErrorBoundary>
	);
};

export { InsightWihErrorBoundary as Insight };
